/* eslint no-nested-ternary: 0 */
import React from 'react';
import moment from 'moment';

class InlineReference extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showInlineReferenceDetails: false };
    }

    openHover = () => {
        if (this.props.showDetailsOnHover) this.setState({ showInlineReferenceDetails: true });
    };

    closeHover = () => {
        if (this.props.showDetailsOnHover) this.setState({ showInlineReferenceDetails: false });
    };

    render() {
        const {
            url,
            children,
            contentState,
            entityKey,
            readOnly,
            isInternalReference,
            cssSelector,
            showDetailsOnHover,
            onClick,
        } = this.props;
        const entityData = contentState.getEntity(entityKey).getData();
        const { url: entityDataUrl, metadata: { state = '', mimeType } } = entityData;
        const { showInlineReferenceDetails } = this.state;

        return (
            <span className="inline-reference-container">
                <a
                    href={url || entityDataUrl}
                    className={`inline-reference ${cssSelector} ${isInternalReference ? 'internal-link' : ''} ${state}`}
                    target={`${isInternalReference ? '' : '_blank'}`}
                    rel={`${isInternalReference ? '' : 'noopener noreferrer'}`}
                    onMouseEnter={this.openHover}
                    onMouseLeave={this.closeHover}
                    data-mimetype={mimeType}
                    onClick={onClick}
                >
                    {
                        readOnly
                        && showDetailsOnHover
                        && showInlineReferenceDetails
                        && <InlineReferenceDetails entityData={entityData} isReady />
                    }
                    <span className={`inline-reference-title ${cssSelector}`}>
                        {children}
                    </span>
                </a>
            </span>
        );
    }
}

class InlineReferenceDetails extends React.Component {
    render() {
        const { entityData, isReady } = this.props;
        const {
            title,
            url,
            metadata: {
                state,
                labels,
                number,
                githubUserName,
                comments,
                created_at,
            },
        } = entityData;

        if (!isReady) {
            return <LoadingContainer />;
        }

        const img = state === 'open' ? '/img/icons/github-icon-open.png'
            : state === 'closed' ? '/img/icons/github-icon-closed.png'
                : '/img/icons/github-icon.png';
        const { 1: repo } = /github.com\/(.+)\/issues/g.exec(url);
        const timeAgo = moment(created_at).fromNow();
        const commentText = comments + (comments === 1 ? ' comment' : ' comments');

        return (
            <div className="hover-container">
                <div className="inner-container">
                    <img src={img} alt="github-icon" className="issue-icon" height="25" />
                    <div className="title">
                        {title}
                        <span className="subtext">{`${repo} #${number}`}</span>
                    </div>
                </div>
                <div className="info-text">
                    {`${githubUserName} opened this issue ${timeAgo} · ${commentText}`}
                </div>
                <Labels labels={labels} />
            </div>
        );
    }
}

const LoadingContainer = () => (
    <div className="hover-container">
        <div className="inner-container">
            <span className="gray loading">Loading</span>
        </div>
    </div>
);

const Labels = (props) => {
    const { labels } = props;
    return (
        <div className="label-container">
            {
                labels && labels.map((label) => {
                    const backgroundColor = `#${label.color}`;
                    const color = (parseInt(backgroundColor, 16) > 0xffffff / 2) ? '#000' : '#fff';
                    return (
                        <span style={{ backgroundColor, color }} className="issue-label" key={label.id}>
                            {label.name}
                        </span>
                    );
                })
            }
        </div>
    );
};

export default InlineReference;
